import React from 'react';
import allRoutes from '../routes/latestRoutes';
import { LoadingOutlined } from "@ant-design/icons";

import { Spin } from 'antd';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';

const RoutePage = ({ api, setPageHeader, route, params, divId, loading }) => {
    const { search } = useLocation();
    const searchParams = queryString.parse(search)
    const routeComponent = (x) => {
        let __route = x.route.split('/v02/:urlCode');
        __route = __route[1].split('/:');
        return route === __route[0]
    }

    const getRouteData = () => {
        let component = allRoutes.find(x => routeComponent(x))?.component;
        return component ? component({ api, setPageHeader: setPageHeader, extraData: { divId: divId }, urlData: { ...searchParams, ...params }, }) : <p style={{
            color: "#e74c3c",
        }}>No Route Found</p>
    }

    return (
        <>
            {
                loading ?
                    <div className='loader'>
                        <Spin indicator={<LoadingOutlined style={{ fontSize: 60 }} />} />
                    </div> :
                    getRouteData()
            }
        </>
    )
};

export default RoutePage;